export const QUERY_KEY = {
  user: "user",
  rooms: "rooms",
  unreadCounts: "unread-counts",
  joinRequests: "join-requests",
  messages: "messages",
  topics: "topics",
  list: "list",
  detail: "detail",
  status: "status",
  chain: "chain",
  tokens: "tokens",
  nfts: "nfts",
  tokenAssets: "token-assets",
  customERC20: "custom-erc20",
  customNFT: "custom-nft",
  nicknames: "nicknames",
  participants: "participants",
  friends: "friends",
  userInfo: "user-info",
  profile: "user-info",
  login: "login",
  pinnedNFTs: "pinned-nfts",
  followerUsers: "follower-users",
  followingUsers: "following-users",
  nftDetail: "nft-detail",
  topParties: "top-parties",
  search: "search",
  blocks: "blocks",
  accountSetting: "account-setting",
  archivedList: "archived-list",
  appConfig: "app-config",
  pinnedMessages: "pinned-messages",
  translationMessages: "translation-messages",
  accountBalance: "account-balance",

  // audience subscription
  subscriptionPlans: "subscription-plans",
  subsPurchased: "subs-purchased",
  subsStats: "subs-stats",
  subscriberHistory: "subscriber-history",
  subsRevenueHistory: "subs-revenue-history",
  userSubsStats: "user-subs-stats",
  userSubscriptions: "user-subscriptions",
  subscriptionStatus: "subscription-status",

  // pay to open
  payToOpenSoldHistory: "pay-to-open-sold-history",
  payToOpenPurchasedHistory: "pay-to-open-purchased-history",
  payToOpenOrders: "pay-to-open-orders",
  payToOpenDetail: "pay-to-open-detail",

  // link metadata
  exchangeRate: "exchange-rate",
  linkMetaData: "link-meta-data",
  nftInfo: "nft-info",

  // dBot
  dBotPermissions: "d-bot-permissions",
  // transaction receipt
  waitForTransactionReceipt: "wait-for-transaction-receipt",

  // public party invitation
  publicPartyInvitation: "public-party-invitation",
};
